// extracted by mini-css-extract-plugin
module.exports = {"chipWrapper":"SectionEnabledChipStyles_chipWrapper__vTZN8","text":"SectionEnabledChipStyles_text__1OaXA"};